export default __webpack_public_path__ + "static/media/1498.414d40e4.png";